<template>
  <div class="app-container" style="padding:0;">
    <list row-key="UserId" ref="list" unit="产品列表" :page="page" show-query :query-params="params" :get-data-func="api.list" @reset="$refs.picker.clear()">
      <template slot="query">
        <el-form-item el-form-item label="单据日期">
          <range-picker style="width:180px !important;" ref="picker" @change="(x) => {params.DocDateStart=x.Start;params.DocDateEnd=x.End}" />
        </el-form-item>
        <el-form-item label="存货名称">
          <el-input style="width:180px;" clearable v-model="params.ProductName" placeholder="请输入存货名称" />
        </el-form-item>
        <el-form-item label="加工阶段">
          <el-select clearable v-model="params.Stage" :disabled="disabled" style="width:180px;">
            <el-option v-for="item in machiningStageList" :key="item.MachiningStageId" :value="item.MachiningStageId" :label="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模具名称">
          <el-input style="width:180px;" clearable v-model="params.MouldName" placeholder="请输入模具名称" />
        </el-form-item>
        <el-form-item label="工单号">
          <el-input style="width:180px;" clearable v-model="params.WorkDocNo" placeholder="请输入工单号" />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input style="width:180px;" clearable v-model="params.OrderNo" placeholder="请输入订单号" />
        </el-form-item>
        <el-form-item label="部门" v-if="params.ProductionType===0">
          <el-input style="width:180px;" clearable v-model="params.DpName" placeholder="请输入部门" />
        </el-form-item>
        <el-form-item label="加工商" v-if="params.ProductionType===1">
          <el-input style="width:180px;" clearable v-model="params.TradeUnitName" placeholder="请输入加工商" />
        </el-form-item>
        <el-form-item label="是否已设置工序" prop="IsProcess">
          <el-select v-model="params.IsProcess" >
            <el-option label="是" :value="true" key="a1"></el-option>
            <el-option label="否" :value="false" key="a2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="ProductNo" label="存货编号" min-width="130" align="left"></el-table-column>
        <el-table-column prop="ProductName" label="存货名称" min-width="120" align="left"></el-table-column>
        <el-table-column prop="ProcessStageName" label="加工阶段" min-width="120" align="left"></el-table-column>
        <el-table-column prop="ProcessUnitId" label="加工单元" min-width="120" align="left"/>
        <el-table-column prop="TemplateName" label="模板" min-width="120" align="left"/>
        <el-table-column prop="ProcessName" label="工序" min-width="120" align="left"/>
        <el-table-column prop="Quantity" label="数量" min-width="120" align="left">
          <template slot-scope="{ row }">
            <el-input v-model="row.Quantity" placeholder="请输入数量"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120" align="left">
          <template slot-scope="{ row }">
            <el-button type="primary" @click="onInquire(row)">查询</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <el-table border class="table_bottom table-line tb-c-head" :data="tableData" style="margin-top: 18px;" @selection-change="onCheckChange">
      <el-table-column type="selection" align="center" fixed :width="50" />
      <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ProductName" label="存货名称" min-width="100" align="center"></el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{row.PropertyName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{row.ColorName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="数量" min-width="100" align="center"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import moment from "moment"
import { forEach } from "lodash";

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  data() {
    return {
      params: {
        IsProcessStage:false,
        IsProcess:false,
        DocDateStart: "",
        DocDateEnd: "",
        ProductName: "",
        Stage: "",
        MouldName: "",
        WorkDocNo: "",
        OrderNo: "",
      },
      data: {},
      commonApi: require("@/api/common/common").default,
      api: require("@/api/ba/product").default,
      machiningStageApi: require("@/api/ba/machiningStage").default,
      bomApi: require("@/api/production/teProduct").default,
      arr: [],
      routesName: '',
      list: [],
      subList: [],
      tableData: [],
      extraList: [],
      TradeUnitId: null,
      machiningStageList: [],
    };
  },
  created() {
    this.machiningStageApi.list({ Status: 1 }).then((res) => {
      this.machiningStageList = res.Data;
    });
  },
  mounted() {
    this.getData();
  },
  methods: {
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (date == undefined || date == '') {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    del() { },
    checkChange(list) {
      this.list = list;
    },
    clear() {
      this.list = [];
      this.subList = [];
    },
    onCheckChange(list) {
      this.subList = list;
    },
    onInquire(row){
      const o = {
        Disabled:0,
        IsDefault:true,
        ProductId:row.ProductId,
        Qty:row.Quantity
      }
      this.bomApi.dtsQtyList(o).then(res => {
        this.extraList = []
        if (res.Code === 0) {
          this.tableData = res.Data[0].DetailModels
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
};
</script>
